function hura_new_pad(number, length){
    var str = '' + number;
    while (str.length < length) {
      str = '0' + str;
    }
    return str;
}
function hura_countdown_timer(id,start_date,target_date,action){
    var $container = document.getElementById('hura-countdown-timer-'+id);
    var dayClass = "hura-countdown-timer-days-"+id;
    var hourClass = "hura-countdown-timer-hours-"+id;
    var minusClass = "hura-countdown-timer-minutes-"+id;
    var secondsClass = "hura-countdown-timer-seconds-"+id;
    var target_date = new Date(target_date);
    var start_date = new Date(start_date);
    var days, hours, minutes, seconds;
    setInterval(function () {
        var current_date = new Date().getTime();
        var seconds_left = (target_date - current_date) / 1000;
        days = parseInt(seconds_left / 86400);
        seconds_left = seconds_left % 86400;
        hours = parseInt(seconds_left / 3600);
        seconds_left = seconds_left % 3600;
        minutes = parseInt(seconds_left / 60);
        seconds = parseInt(seconds_left % 60);
        document.getElementById(dayClass).innerHTML = days;
        document.getElementById(hourClass).innerHTML = hura_new_pad(hours,2);
        document.getElementById(minusClass).innerHTML = hura_new_pad(minutes,2);
        document.getElementById(secondsClass).innerHTML = hura_new_pad(seconds,2);
        if(target_date<current_date){
          if(action=='true'){
            $container.style.display = 'block';
            $container.querySelectorAll('.hura-countdown-timer-notice')[0].style.display = 'block';
            $container.querySelectorAll('.hura-countdown-timer-main')[0].style.display = 'none';
          }else{
            $container.style.display = 'none';
          }          
        }else{
          if(start_date<=current_date){
            $container.style.display = 'block';
          }
        }        
    }, 1000);	
    setTimeout(function(){
      $container.querySelectorAll('.hura-countdown-timer-wrapper')[0].style.opacity = 1;
    },1001);
}
  var countdownTimerElements = document.querySelectorAll('.hura-countdown-timer-container');
  if (countdownTimerElements.length > 0) {
    countdownTimerElements.forEach(function (element) {
      var id = element.getAttribute('data-id');
      var start = element.getAttribute('data-start');
      var end = element.getAttribute('data-end');
      var action = element.getAttribute('data-action');
      hura_countdown_timer(id, start, end, action);
    });
  }